<template>
  <div>
    <b-form-select v-model="selected" :options="options" @change="$emit('input', selected)"></b-form-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: this.$t('Todos') },
        { value: 0, text: this.$t('Não') },
        { value: 1, text: this.$t('Sim') }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
